import { createAsyncThunk } from "@reduxjs/toolkit";

export const createFetchThunk = ({ typePrefix, apiFn, errorMessage }) =>
  createAsyncThunk(
    typePrefix,
    async (arg, { getState, rejectWithValue }) => {
      const sliceName = typePrefix.split("/")[0];
      const state = getState()[sliceName];
      const entry = state?.byKey?.[arg];

      // cache hit ONLY if data already fetched
      if (entry?.hasFetched) {
        return rejectWithValue("__CACHED__");
      }

      try {
        const res = await apiFn(arg);
        return res.data?.data ?? [];
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message || errorMessage
        );
      }
    }
  );
